<template>
    <v-row class="ma-0">
		<v-col class="pa-0" cols="12" ref="notificationssetting">
            <v-card class="flex mb-2 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Impostazioni Notifiche</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>

                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox
                            color="primary"
                            hide-details
                            v-model="settings['notify_expiring_vehicle_expiration']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Scadenza Veicolo in Scadenza</v-list-item-title>
                            <v-list-item-subtitle>Ricevi una notifica quando una scadenza di un veicolo sta per scadere
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-slide-y-transition>
                    <v-list two-line subheader class="background-2 px-2 pb-2 pt-0" v-if="settings['notify_expiring_vehicle_expiration']">
                        <v-list-item>
                            <v-list-item-action>
                            </v-list-item-action>
                            <v-list-item-content style="height: 90px; padding-top: 24px;">
                                <v-text-field
                                    label="Numero giorni prima"
                                    v-model="settings['notify_expiring_vehicle_expiration_day_before']"
                                    type="number"
                                    outlined
                                    dense
                                    required
                                    :error-messages="errors.collect('daybefore1')"
                                    v-validate="'required'"
                                    data-vv-name="daybefore1"
                                    data-vv-as="Numero giorni prima"
                                ></v-text-field>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-slide-y-transition>

                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['notify_expired_vehicle_expiration']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Scadenza Veicolo Scaduta</v-list-item-title>
                            <v-list-item-subtitle>Ricevi una notifica quando una scadenza di un veicolo è scaduta
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
					<v-btn text class="pa-2 mx-2" color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>

            </v-card>

        </v-col>

    </v-row>
</template>

<script>
    import Vue from 'vue'
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'

    export default {
        name: 'vehicles-options',
		mixins: [SettingsOptionsMixin],
        props: {},
        data() {
            return {
                model: 'vehicle',
                settings: {
                    'notify_expiring_vehicle_expiration': false,
                    'notify_expired_vehicle_expiration': false,
                    'notify_expiring_vehicle_expiration_day_before': null,
                },
            }
        },

        watch: {
            settings: {
                handler() {
                    if(!this.settings['notify_expiring_vehicle_expiration']) {
                        Vue.set(this.settings, 'notify_expiring_vehicle_expiration_day_before', null)
                    }
                },
                deep: true,
            }
        },
    }
</script>

<style scoped>

</style>
